export const REDUCED_CARD_THUMBNAIL_SIZES = {
  small: 60,
  medium: 100,
  large: 250,
  'extra-large': 400
};